import  { useState, useEffect } from "react";
import { actualizaDispensa, getDispensaInt,  } from "../../services/dispensador";
import PropTypes from 'prop-types';
import Modal from "../modal";
import { ErrorContext } from "../../utils/context/error";
import MultiSelect from "../../hooks/multiselect";

function DispensaModal({ show, AreaI, DispensaI, Tag, handleshow, handleFiltrar }) 
{
  const [habilita, setHabilita] = useState(false);
  const [datos, setDatos] = useState([]);
  
  const [dispensaId, setDispensaId] = useState(0);
  const [nombreDisp, setNombreDisp]= useState("");
  const [area, setArea] = useState([]);
  const [codigovinc, setCodigoVinc] = useState("");
  const [descripcion, setDescripcion] = useState("");
  const [tipodispensa, setTipodispensa] = useState("");
  const [imprime, setImprime] = useState('NO');
  const [lector, setLector] = useState('NO');
  const [urllector, setLectorUrl] = useState('NO');
  const [impresora, setImpresora] = useState("");
  const [puerto, setPuerto] = useState("");
  const [Titulo, setTitulo] = useState("");
  const {setShowToast, setOpciones } = ErrorContext();
  const [activeTab, setActiveTab] = useState("tab1");
  const [mensajevalid, setMensajevalid] = useState("* Campo Obligatorio.")
  const [validar, setValidar] = useState(false);
  const [validarDisp, setvalidaDisp] = useState(false); 
  
  //---- Boton Cancelar
  const handleCancel = async () => 
    {
      handleshow(false);
    };
//---- Boton Aceptar----------------------------------------------------------------------------------------------------
  const handleAceptar = async () => 
    {
      setvalidaDisp(false);
      let actguardar = true;
      const areaIdI= datos.join(",");
      setValidar(false);
      
      setHabilita(true);
      setShowToast(false);

      
      if ((tipodispensa==='')  ||(datos.length===0) || (nombreDisp===''))
      {
        setValidar(true)
        actguardar = false;
      }
      else
      {
        if (tipodispensa ==='U' && datos.length >1)
        {
          setvalidaDisp(true)
          setMensajevalid('* No se puede seleccionar más de una area, para el tipo de dispensador')
          actguardar = false;
        }
        if (tipodispensa ==='M' && datos.length === 1)
        {
          setvalidaDisp(true)
          setMensajevalid('* No se puede seleccionar una sola area, para el tipo de dispensador')
          actguardar = false;
        }
      }
      
      if (actguardar)
      {
         const response = await actualizaDispensa(
           {
              datos,
              dispensaId,
              nombreDisp,
              descripcion,
              codigovinc,
              imprime,
              impresora,
              puerto,
              Tag,
              lector,
              urllector,
              tipodispensa,
              areaIdI
          });
         if (response) 
           {
              if (response.status === 200) 
               {
                  handleFiltrar(0);
                  handleshow(false);
               } 
              else 
               {
                 const Mensaje = response.message;
                 const opc = { type: "Danger", message: Mensaje, active: true };
                 setOpciones(opc);
                 setShowToast(true);
               } 
           }
         else 
           {
             const Mensaje = response.message;
             const opc = { type: "Danger", message: Mensaje, active: true };
             setOpciones(opc);
             setShowToast(true);
           } 
      }       
      setHabilita(false);
    };

  //---- Servicio por area e Id ----------------------------------------------------------------------------------------
  const fillDispensaInt = async (dispensaId) => 
    {
       setShowToast(false);
       const response = await getDispensaInt(dispensaId);
       if (response) 
         {
            if (response.status === 200) 
              {
                 setNombreDisp(response.data.data[0]?.NombreDisp||"");
                 setCodigoVinc(response.data.data[0]?.CodigoVinc||"");
                 setImprime(response.data.data[0]?.Imprime||"NO");
                 setLector(response.data.data[0]?.Lector||"NO");
                 setImpresora(response.data.data[0]?.Impresora||"");
                 setPuerto(response.data.data[0]?.Puerto||"");
                 setDescripcion(response.data.data[0]?.Descripcion||"");
                 setLectorUrl(response.data.data[0]?.UrlLector||"");
                 setTipodispensa(response.data.data[0]?.TipoDispensa||"");
                 
                 setDispensaId(DispensaI);
                 setArea(response.data.area);
                // setDatos(response.data.dispensa);
                 setDatos(response.data.dispensa.map(item => item.AreaId));
                 
                 if (Tag === 0) setCodigoVinc(generarClave(8));
              } 
            else 
            {
              const Mensaje = response.message;
              const opc = { type: "Danger", message: Mensaje, active: true };
              setOpciones(opc);
              setShowToast(true);
           }
        }
    };
   
//----------------------------------------------------------------------------------------------------------------------
    const Random = (array) => 
      {
        let posicionActual = array.length;
         while (0 !== posicionActual) 
          {
            const posicionAleatoria = Math.floor(Math.random() * posicionActual);
            posicionActual--;
            //"truco" para intercambiar los valores sin necesidad de una variable auxiliar
            [array[posicionActual], array[posicionAleatoria]] = [
             array[posicionAleatoria], array[posicionActual]];
          }
       return array;
      }

//----------------------------------------------------------------------------------------------------------------------
   function generarClave(cantidad) 
    {
       const caracteres = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789@%/?!=".split("");
       Random(caracteres);
       return caracteres.slice(0,cantidad).join("")
    }
   
//----------------------------------------------------------------------------------------------------------------------
   useEffect(() => 
    {
     if (show) 
      { setActiveTab('tab1');
        setValidar(false);
        setNombreDisp("");
        setImprime('NO');
        setLector('NO');
        setImpresora("");
        setPuerto("");
        setDescripcion("");
        setLectorUrl('');
        setDispensaId('');
        //setAreaId(AreaI);
        setDatos([]);
        setDispensaId(DispensaI);
        fillDispensaInt(DispensaI);
      
        if (Tag !== 0) 
          {
            if (Tag === 1) setTitulo("Editar Dispensador (" + DispensaI + ")");
            if (Tag === 2) setTitulo("Eliminar Dispensador (" + DispensaI + ")");
          } 
        else 
         {
          setDispensaId(0);
          setTitulo("Nuevo Dispensador");
         }
      }
    }, [show]);

    return (
    <>
       <Modal isOpen={show} onClose={()=>handleshow(false)} title={Titulo}>
          <div className="flex lg:w-[25rem] min-h-[27.5rem]">
            <div className="flex flex-col w-full items-center justify-center">
                <div className="w-full max-w-2xl mx-auto">
                     <div className="flex border-b border-stone-200 gap-x-4">
                        <button 
                           className={`px-4 py-2 text-sm font-medium flex-1 border-b-2 border-border text-border ${activeTab === "tab1"
                                       && "border-default text-default hover:text-default"
                                      }`}
                           onClick={() => setActiveTab("tab1")}
                        >
                           Información General
                        </button>
                        <button
                           className={`px-4 py-2 text-sm font-medium flex-1 border-b-2  border-border text-border ${activeTab === "tab2"
                                       && "font-medium border-default text-default hover:text-default"
                                      }`}
                           onClick={() => setActiveTab("tab2")}
                          >
                         Configurar Dispositivos
                        </button>
                     </div>
                </div> 
                 

              <form noValidate className="flex w-full flex-col min-h-[27.5rem]">
                {/* tab1 */}
                {activeTab === "tab1" && ( 
                  <div className="flex flex-col w-full h-full mt-3">
                      <div className="w-full ">
                        <label>Tipo Dispensación</label>
                        <select id="tipodispensa" name="tipodispensa" value={tipodispensa || ""} 
                                onChange={(e) => setTipodispensa(e.target.value)} 
                                label="tipodispensa" disabled={Tag === 2 || Tag === 1}
                                className={`${validar && tipodispensa === "" ? `validar`: ""}`}
                        >
                            <option value="" disabled>
                               Seleccionar un Tipo Dispensación...
                            </option>
                            <option value="U">
                               Una sola área
                            </option>
                            <option value="M">
                               Múltiples áreas
                            </option>
                        </select>
                        {(validar && tipodispensa === "")  && (
                        <p className="obligatorio">
                            * Campo Obligatorio.
                        </p>
                      )}
                      </div>      

                      <div className="w-full mt-3">
                        <label>Area</label>
                        <MultiSelect
                          data={area}
                          variables={["AreaId", "NombreArea"]}
                          pholder="Seleccione una o más áreas"
                          setreturn={setDatos}
                          seleccionado={datos}
                          className={(validar && datos.length === 0) || validarDisp ? "validar" : "" }
                        />
                        {(validar && areaId === '') || (validarDisp) && (
                        <p className="obligatorio">
                            {mensajevalid}
                        </p>
                      )}
                      </div>  

                      <div className="w-full mt-4">
                         <label>Nombre Dispensador</label>
                            <input type="text" name='searchid' value={nombreDisp || ""} placeholder="Ingresa el nombre para el Dispensador" 
                                onChange={(e)=> setNombreDisp(e.target.value)}
                                autoComplete="off" 
                                className={`${validar && nombreDisp === "" ? `validar`: ""}`}
                                disabled={Tag === 2}>
                            </input>
                            {validar && nombreDisp === "" && (
                               <p className="obligatorio">
                                  * Campo Obligatorio.
                               </p>
                            )}
                      </div>
                      
                      <div className="w-full mt-4">
                         <label>Descripcion</label>
                            <textarea name='searchid' value={descripcion || ""} placeholder="Ingresa una Descripcion" 
                                onChange={(e)=> setDescripcion(e.target.value)}
                                autoComplete="off" 
                                
                                disabled={Tag === 2}>
                            </textarea>
                      </div>

                      <div className="w-full mt-2">
                         <label>Código de Vinculación</label>
                            <input type="text" name='searchid' value={codigovinc || ""} placeholder="Ingresa el nombre para el Dispensador" 
                                onChange={(e)=> setCodigoVinc(e.target.value)}
                                autoComplete="off" 
                                disabled={Tag === 2}>
                            </input>
                      </div>
                    </div>
                   )}
                    {/* ta 2 */}
                   {activeTab === "tab2" && (  
                     <div className="flex flex-col w-full h-full mt-3">
                      <div className="flex mt-4">
                         <input type="checkbox" className="mr-2" checked={imprime === "SI"} onChange={(e) => e.target.checked ? setImprime("SI") : setImprime("NO")}/>
                         <label className="">Imprimir los Tickets</label>   
                     </div>

                     <div className="flex flex-row mt-1 gap-x-4">
                         <div className="w-full">
                             <label>Impresora</label>
                             <input type="text" value={impresora} 
                                    onChange={(e) => setImpresora(e.target.value)} 
                                    placeholder="Nombre de la Impresora" 
                                    autoComplete="off"
                                    disabled={Tag === 2}>
                             </input>
                         </div>
                         <div className="w-full">
                            <label>Puerto</label>
                            <input type="text" value={puerto} 
                                    onChange={(e) => setPuerto(e.target.value)} 
                                    placeholder="0000" 
                                    autoComplete="off"
                                    disabled={Tag === 2}>
                             </input>
                         </div>
                    </div>
                    <div className="flex mt-4">
                         <input type="checkbox" className="mr-2" checked={lector === "SI"} onChange={(e) => e.target.checked ? setLector("SI") : setLector("NO")}/>
                         <label className="">Usar Lector de Documentos de Identidad</label>   
                     </div>
                     <div className="w-full mt-1"> 
                        <label>Ruta Conexión</label>
                        <input type="text" value={lector === "NO"?'':urllector} 
                            onChange={(e) => setLectorUrl(lector === "NO"?'':e.target.value)} 
                            placeholder="http://localhost:puerto" 
                            autoComplete="off"
                            disabled={Tag === 2 || lector === "NO"}>
                        </input>
                     </div>

                  </div>
                  
                  
                  )}
                  <div className="flex w-full gap-4 mt-6 justify-end">
                          <button name="Aceptar" className="btnprimary" onClick={handleAceptar} disabled={habilita} type="button">Aceptar</button>
                          <button name="Cancelar" className="" onClick={handleCancel} disabled={habilita} type="button">Cancelar</button>
                  </div>    
              </form> 
              </div>  
          </div>    
        </Modal>         
    </>
  );
}
DispensaModal.propTypes = {
  show: PropTypes.bool.isRequired,
  AreaI: PropTypes.array.isRequired, 
  DispensaI: PropTypes.number.isRequired,
  Tag: PropTypes.number.isRequired,
  handleshow: PropTypes.func.isRequired,
  handleFiltrar: PropTypes.func.isRequired,
};

export default DispensaModal;
